import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/customers/page.tsx");
